import {ParticularShift, Shift} from '@hconnect/common/types'
import {getRequiredShift} from '@hconnect/common/utils'
import {Moment} from 'moment-timezone'
import React, {useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE} from '../../consts'

import {SimpleShiftPicker} from './SimpleShiftPicker'

type ShiftPickerProps = {
  error?: boolean
  enableSelectRange?: boolean
  localDate: Moment
  localStartDate?: Moment
  label?: React.ReactNode
  onChange: (value: ParticularShift | [ParticularShift, ParticularShift]) => void
  shifts: Shift[]
  plantId: string
}

const generateShiftDate = (date: Moment, shifts: Shift[]) => {
  const selectedShift = getRequiredShift(date, shifts)
  return selectedShift.startDate
}

export const ShiftPicker: React.FC<ShiftPickerProps> = ({
  localDate,
  localStartDate,
  label,
  error,
  shifts,
  plantId,
  ...rest
}) => {
  const {t} = useTranslation(SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE)
  if (!localDate) {
    throw new Error('missing localDate prop in ShiftPicker')
  }
  const date = useMemo(() => {
    return generateShiftDate(localDate, shifts)
  }, [localDate, shifts])
  const startDate = useMemo<Moment | undefined>(() => {
    if (!localStartDate) return
    return generateShiftDate(localStartDate, shifts)
  }, [localStartDate, shifts])
  return (
    <div data-test-id="simple-shift-picker" style={{height: '56px'}}>
      <SimpleShiftPicker
        error={error}
        date={startDate || date}
        dateRange={startDate && date ? [startDate, date] : undefined}
        noAutoClose={true}
        label={label || t('shiftEvent.label.shift')}
        shifts={shifts}
        plantId={plantId}
        {...rest}
      />
    </div>
  )
}
